<h1 class="matp-page-title">アカウント一覧</h1>

<!-- アカウント種類で切替 -->
<div class="tw-my-2">
  <mat-button-toggle-group
    class="matp-button-toggle-group matp-button-inactive"
    aria-label="アカウント種類"
    [hideSingleSelectionIndicator]="'true'"
    [(ngModel)]="selectedUserType"
    name="selectRole"
  >
    @if (loggedInUserRole === "system_admin") {
      <mat-button-toggle value="system_admin" class="toggle-system_admin"
        >マクニカ管理者</mat-button-toggle
      >
    }
    <mat-button-toggle value="tenant_admin" class="toggle-tenant-admin"
      >テナント管理者</mat-button-toggle
    >
    <mat-button-toggle value="tenant_user" class="toggle-tenant_user"
      >テナントユーザー</mat-button-toggle
    >
  </mat-button-toggle-group>
</div>

<!-- アカウント一覧 -->
<mat-card
  class="matp-card !tw-bg-gray-100"
  [ngClass]="{
    'matp-bg-system-admin': selectedUserType === 'system_admin',
    'matp-bg-tenant-admin': selectedUserType === 'tenant_admin',
    'matp-bg-tenant-user': selectedUserType === 'tenant_user',
  }"
>
  <app-account-list-table
    [accountList]="accountList"
    [tenantList]="tenantList"
    [deviceTagList]="deviceTagList"
    [loggedInUserRole]="loggedInUserRole"
    [selectedUserType]="selectedUserType"
    [readonly]="tableReadonly"
    (created)="openAccountEditDialog()"
    (updated)="openAccountEditDialog($event)"
    (deleted)="deleteAccount($event)"
  ></app-account-list-table>
</mat-card>
